/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CedulaCalculations from './CedulaCalculations';
import VeterinaryCalculations from './VeterinaryCalculations';
import FireSafety from './FireSafety';
import * as actions from '../action';
import * as c from '../constant';

import UpdateModalFees from './modal/UpdateModalFees';
import AddModalFees from './modal/AddModalFees';

function NewOtherFeesContent({
  // history,
  // formData,
  // setFormData,
  handleAddModal,
  handleEdit,
  handleRemove,
  // creating,
  // updating,
  // deleting,
  newOtherFeesId,
  getSingleNewOtherFees,
  getNewOtherFeesList,
  newOtherFeesInfo,
  ordinanceRevisionId,
  // calculationZoningFeeList,
  removeCalculationZoningFees,
  getCedulaCalculationList,
  cedulaCalculationList,
  getVeterinaryCalculationList,
  veterinaryCalculationList,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getSingleNewOtherFees(newOtherFeesId);
    getCedulaCalculationList(newOtherFeesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getSingleNewOtherFees(newOtherFeesId);
    getCedulaCalculationList(newOtherFeesId);
    getVeterinaryCalculationList(newOtherFeesId);
    // getFireSafetyList();
  }, [newOtherFeesId]);

  const authProfile = getJson('profile') || {};
  const [token, setToken] = useState('');
  const permissions = getJson('permissions');

  const srcDownload = `${
    process.env.REACT_APP_WS
  }api/v1/bpls/administrator/report/other_fees/generate_pdf?bearer_token=${token}
  &email=${_.get(
    authProfile,
    'email'
  )}&ordinance_revision_id=${ordinanceRevisionId}`;

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);
  }, []);

  // for zoning fees, will rename later
  // const handleOtherFeesUpdateModal = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <UpdateModalFees
  //         data={calculationZoningFeeList}
  //         id={newOtherFeesId}
  //         ordinanceRevisionId={ordinanceRevisionId}
  //       />
  //     ),
  //     title: 'Update Other Fee Modal',
  //     modalSize: 'modal-md',
  //   });
  // };

  // const handleOtherFeesAddModal = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <AddModalFees
  //         data={calculationZoningFeeList}
  //         id={newOtherFeesId}
  //         ordinanceRevisionId={ordinanceRevisionId}
  //       />
  //     ),
  //     title: 'Add Other Fee Modal',
  //     modalSize: 'modal-md',
  //   });
  // };

  // const handleOtherFeesRemove = data => e => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to remove this other fee?',
  //     () => {
  //       removeCalculationZoningFees(newOtherFeesId, _.get(data, '0.id'), () => {
  //         setFormData({
  //           ...formData,
  //           keyword: '',
  //         });
  //         getNewOtherFeesList();
  //         history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
  //         getSingleNewOtherFees(newOtherFeesId);
  //       });
  //       // action here...
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  /*
   * filterDescriptionTags: (function) check if the string from first param matches at least 1 word/string from second param, returns bool true or false
   * dataString: (string) from description that will be checked for specific words
   * arrayString: (string) or words that needs to match with words in dataString
   */
  // const filterDescriptionTags = (dataString, arrayString) => {
  //   const stringArr = dataString.split(',') || dataString;
  //   return stringArr.some(item => arrayString.includes(item));
  // };

  // zoning fee filters
  const zoningFeeLists = [
    'ZONING',
    'ZONING FEE',
    'ZONING APPLICATION',
    'ZONING APPLICATION FEE',
    'ZONING PROCESSING FEE',
  ];

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
            >
              Add Other Fee &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
            {Acl(permissions, ['E2E BPLS TAX REVENUE GENERATE PDF']) && (
              <a
                className="btn btn-primary cms-bg-color-primary cms-outline-primary     ml-1"
                href={srcDownload}
                target="_blank"
                without="true"
                rel="noopener noreferrer"
              >
                <i className="fas fa-print" /> Generate PDF
              </a>
            )}
          </div>
        </div>
        {!_.isEmpty(newOtherFeesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(newOtherFeesInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(newOtherFeesInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(newOtherFeesInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(newOtherFeesInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Code
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(newOtherFeesInfo, 'attributes.code')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(newOtherFeesInfo, 'attributes.name')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Description
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(newOtherFeesInfo, 'attributes.description')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Type
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(newOtherFeesInfo, 'attributes.type')}</b>
                        </td>
                      </tr>
                      {_.get(newOtherFeesInfo, 'attributes.type') ===
                        'BASIC' && (
                        <tr>
                          <td className="text-dark" width="250">
                            Amount
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>
                              {_.get(newOtherFeesInfo, 'attributes.amount')}
                            </b>
                          </td>
                        </tr>
                      )}
                      {}
                      {['VETERINARY', 'ZONING PROCESSING', 'FIRE SAFETY'].indexOf(
                        _.get(newOtherFeesInfo, 'attributes.type')
                      ) > -1 && (
                        <tr>
                          <td className="text-dark" width="250">
                            Percentage
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>
                              {_.get(newOtherFeesInfo, 'attributes.percentage')}
                            </b>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="text-dark" width="250">
                          For New
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {' '}
                            {_.get(newOtherFeesInfo, 'attributes.for_new')
                              ? 'Yes'
                              : 'No'}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          For Renewal
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {' '}
                            {_.get(newOtherFeesInfo, 'attributes.for_renewal')
                              ? 'Yes'
                              : 'No'}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr />
                  {_.get(newOtherFeesInfo, 'attributes.type') === 'CEDULA' && (
                    <CedulaCalculations
                      cedulaCalculationList={cedulaCalculationList}
                      newOtherFeesId={newOtherFeesId}
                      ordinanceRevisionId={ordinanceRevisionId}
                    />
                  )}
                  {_.get(newOtherFeesInfo, 'attributes.description') ===
                    'VETERINARY REGISTRATION FEE' && (
                    <VeterinaryCalculations
                      veterinaryCalculationList={veterinaryCalculationList}
                      newOtherFeesId={newOtherFeesId}
                      ordinanceRevisionId={ordinanceRevisionId}
                    />
                  )}
                  {_.get(newOtherFeesInfo, 'attributes.type') ===
                    'FIRE SAFETY' && (
                    <FireSafety
                      // fireSafetyList={fireSafetyList}
                      newOtherFeesId={newOtherFeesId}
                    />
                  )}
                  {/* Zoning Fee: (Todo: move to a new component later) */}
                  {/* {filterDescriptionTags(
                    _.get(newOtherFeesInfo, 'attributes.description'),
                    zoningFeeLists
                  ) &&
                    (!_.isEmpty(
                      _.get(calculationZoningFeeList, '0.attributes')
                    ) ? (
                      ''
                    ) : (
                      <div className="d-flex align-items-center justify-content-end mb-3">
                        <button
                          type="button"
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary "   
                          onClick={handleOtherFeesAddModal}
                        >
                          {creating ? (
                            <i className="fa fa-spin fa-spinner" />
                          ) : (
                            'ADD ZONING FEES'
                          )}
                        </button>
                      </div>
                    ))} */}
                  {/* {filterDescriptionTags(
                    _.get(newOtherFeesInfo, 'attributes.description'),
                    zoningFeeLists
                  ) &&
                    !_.isEmpty(
                      _.get(calculationZoningFeeList, '0.attributes')
                    ) && (
                      <div className="form-wrapper p-3">
                        <div className="d-flex align-items-center justify-content-end">
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary     mr-2"
                            onClick={handleOtherFeesUpdateModal}
                          >
                            {updating ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              'Update'
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleOtherFeesRemove(
                              calculationZoningFeeList
                            )}
                          >
                            {deleting ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              'delete'
                            )}
                          </button>
                        </div>
                        <hr />
                        <table className="transaction-table table table-borderless table-sm mt-3">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="250">
                                Zoning Application Fee
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    calculationZoningFeeList,
                                    '0.attributes.zoning_application_fee'
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Zoning Processing Fee
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    calculationZoningFeeList,
                                    '0.attributes.zoning_base_line'
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Zoning Fee
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    calculationZoningFeeList,
                                    '0.attributes.zoning_processing_fee_percentage'
                                  )}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )} */}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

NewOtherFeesContent.propTypes = {
  // history: PropTypes.instanceOf(Object).isRequired,
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  // formData: PropTypes.instanceOf(Object).isRequired,
  // setFormData: PropTypes.instanceOf(Function).isRequired,

  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  newOtherFeesInfo: PropTypes.instanceOf(Object).isRequired,
  getCedulaCalculationList: PropTypes.instanceOf(Function).isRequired,
  cedulaCalculationList: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  removeCalculationZoningFees: PropTypes.instanceOf(Function).isRequired,
  // calculationZoningFeeList: PropTypes.instanceOf(Object).isRequired,
  getVeterinaryCalculationList: PropTypes.instanceOf(Function).isRequired,
  veterinaryCalculationList: PropTypes.instanceOf(Array).isRequired,
  // creating: PropTypes.bool.isRequired,
  // updating: PropTypes.bool.isRequired,
  // deleting: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  creating: api.loading.indexOf(c.CREATE_CALCULATION_ZONING_FEES) > -1,
  updating: api.loading.indexOf(c.UPDATE_CALCULATION_ZONING_FEES) > -1,
  deleting: api.loading.indexOf(c.REMOVE_CALCULATION_ZONING_FEES) > -1,
  newOtherFeesInfo: _.get(api, `${c.GET_SINGLE_NEW_OTHER_FEES}.item`) || {},
  newOtherFeesId: _.get(match, 'params.newOtherFeesId') || '',
  cedulaCalculationList:
    _.get(api, `${c.GET_CEDULA_CALCULATION_LIST}.list`) || {},
  veterinaryCalculationList:
    _.get(api, `${c.GET_VETERINARY_CALCULATION_LIST}.list`) || [],
  fireSafetyList: _.get(api, `${c.GET_FIRE_SAFETY_LIST}.res`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewOtherFeesContent);
